import Vue from 'vue'
import configs from '@/config'

let resource = null
const accountsPath = `${configs.baseUrl}/api/accounts`

const actions = {
  getSalesAssistedContract: {
    method: 'POST',
    url: `${accountsPath}/sales-assisted-contract`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getSalesAssistedContract = async (payload) => {
    const res = await resource.getSalesAssistedContract(payload)
    return res.body
}

export default {
  initResource,
  getSalesAssistedContract,
}